import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import createPersistedState from 'vuex-persistedstate'
import * as types from './types'
import auth from './modules/auth/auth.store'
import announcement from './modules/announcement/announcement.store'
import products from './modules/products/products.store'
import coupons from './modules/coupons/coupons.store'
import cart from './modules/cart/cart.store'
import registration from './modules/registration/registration.store'
import profile from './modules/profile/profile.store'
import collections from './modules/collections/collection.store'
import addresses from './modules/addresses/addresses.store'
import entry from './modules/entry/entry.store'
import entries from './modules/entries/entries.store'
import classes from './modules/class-registration/classes.store'
import navigation from './modules/navigation/navigation.store'
import newsletter from './modules/newsletter/newsletter.store'
import decathlon from './modules/consents/decathlon.store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// These modules hold nothing that belongs to the logged in user: the token is cleared by AUTH_LOGOUT,
// the collections are public (and language dependent) data
const KEEP_ON_LOGOUT = ['auth', 'navigation', 'collections']

// Must be the first plugin: it snapshots the pristine state before vuex-persistedstate rehydrates it.
// The reset is deferred until the logout navigation finished (see router.js), so the page still on
// screen does not render with an emptied profile/cart in between.
const userStateResetPlugin = store => {
  const initialState = cloneDeep(store.state)
  store.userStateResetPending = false

  store.subscribe(mutation => {
    if (mutation.type === types.AUTH_LOGOUT) {
      store.userStateResetPending = true
    }
  })

  store.resetUserState = () => {
    store.userStateResetPending = false
    store.commit(types.RESET_USER_STATE, initialState)
  }
}

export default new Vuex.Store({
  mutations: {
    [types.RESET_USER_STATE](state, initialState) {
      clearInterval(state.cart.timerIntervalID)
      Object.keys(initialState)
        .filter(moduleName => !KEEP_ON_LOGOUT.includes(moduleName))
        .forEach(moduleName => Vue.set(state, moduleName, cloneDeep(initialState[moduleName])))
    }
  },
  modules: {
    auth,
    announcement,
    products,
    coupons,
    cart,
    registration,
    profile,
    collections,
    addresses,
    entry,
    entries,
    classes,
    navigation,
    newsletter,
    decathlon
  },
  plugins: [
    userStateResetPlugin,
    createPersistedState({
      key: 'entryui-bsi',
      paths: [
        'cart.cart',
        'cart.barionCart',
        'cart.selectedCoupons',
        'profile',
        'registration.user',
        'collections'
      ]
    })
  ],
  strict: debug
})
